const ReactDOM = require('../../../../node_modules/react-dom');

/**
 * Compatibility helper for ReactDOM.findDOMNode which was removed in React 19.
 *
 * @param {*} node - The component instance, DOM node, or ref object.
 * @returns {Element|null} - The resolved DOM element or null.
 */
function findDOMNode(node) {
    if (!node) {
        return null;
    }
    if (typeof Element !== 'undefined' && node instanceof Element) {
        return node;
    }
    if (typeof node.nodeType === 'number') {
        return node;
    }
    if (node.current) {
        // eslint-disable-next-line react/no-find-dom-node
        return findDOMNode(node.current);
    }

    return null;
}

const ReactDOMCompat = {
    ...ReactDOM,
    findDOMNode,
    default: undefined
};

ReactDOMCompat.default = ReactDOMCompat;

module.exports = ReactDOMCompat;

